import { render, staticRenderFns } from "./WorkViewReports.vue?vue&type=template&id=21971479&"
import script from "./WorkViewReports.vue?vue&type=script&lang=js&"
export * from "./WorkViewReports.vue?vue&type=script&lang=js&"
import style0 from "./WorkViewReports.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports